import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="text-lg font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              {siteInfo.name}
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-sm">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-950 mb-3">分类导航</h5>
            <ul className="space-y-2">
              {categories.slice(0, 3).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-950 mb-3">更多分类</h5>
            <ul className="space-y-2">
              {categories.slice(3).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-950 mb-3">关于我们</h5>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href={`mailto:${siteInfo.email}`} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="Email">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 版权所有。
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供参考，不能替代专业医疗诊断。
          </p>
        </div>
      </div>
    </footer>
  );
}